var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GrayHexContainer',{staticClass:"py-12"},[_c('div',[_c('RegistrationPrompt',{staticClass:"mx-auto",attrs:{"button-id":"company-size-button-footer"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }